import React, { useState } from 'react'
import ModalCustom from '../../../components/modal-custom'

import ActionImportExcel from '../../../components/income-dif/ActionImportExcel'
import { importIncomeLoanSLFAPI } from '../../../services/income/loan-slf'
import SwalCustomSuccess from '../../../alert/swal-success'
import Error_false from '../../../components/error/error-false'
import ButtonDownloadExcel from '../../../components/income-dif/ButtonDownloadExcel'
import ExcelApps from '../template/load-SLF.xlsx'

export default function ModalImportFile({
  orgId,
  open,
  onCancel,
  fnGetData,
  data
}) {
  const [isSubmit, setIsSubmit] = useState(false)

  const handleSubmit = async (d) => {
    setIsSubmit(true)
    const body = {
      orgId,
      loanSlfList: d.map((l) => ({
        period: l.date,
        idCard: l['ID Card'] + '',
        amounts: l['Amount']
      }))
    }

    const resp = await importIncomeLoanSLFAPI(body)
    setIsSubmit(false)
    if (!resp) return
    if (resp.status) {
      SwalCustomSuccess().then(() => {
        onCancel()
        fnGetData()
      })
    } else {
      Error_false(resp)
    }
  }

  return (
    <ModalCustom
      maskClosable={false} // ป้องกันการปิดเมื่อคลิกที่ mask (backdrop)
      keyboard={false} // ป้องกันการปิดเมื่อกดปุ่ม Esc
      open={open}
      onCancel={onCancel}
    >
      <div>
        <h5>{data ? 'Update' : 'Add'} Import</h5>
        <ButtonDownloadExcel fileName="template-SLF" ExcelApps={ExcelApps} />
        <ActionImportExcel isSave={isSubmit} handleSubmit={handleSubmit} />
      </div>
    </ModalCustom>
  )
}
